import theme from 'theme';

// Design tokens for the app shell. Shared values are read off the MUI theme rather than restated,
// so the rail cannot drift from the buttons beside it. Only the rail-on-dark text ramp is local:
// it paints on Ebony Clay and has no counterpart in the theme's palette.
const { palette } = theme;

export const RAIL_WIDTH = 262;
export const RAIL_WIDTH_COLLAPSED = 72;
export const APPBAR_HEIGHT = 58;

// Below this the rail gives way to the mobile bottom bar. It replaces the 768px
// line the old top bar drew by hand, and matches Hub's own desktop cut-off.
export const DESKTOP_QUERY = '(min-width:992px)';

export const RAIL_TRANSITION = 'width 200ms cubic-bezier(.2,0,0,1)';

export const C = {
  ink: palette.brandBlack.main,
  turquoise: palette.primary.main,
  error: palette.error.main,
  warning: palette.warning.main,
  page: palette.background.default,

  // Turquoise is reserved for focus, links and the active nav item, so the
  // readable-on-white and tint variants it needs are derived here.
  turquoiseText: '#00708c',
  turquoiseCheck: '#00607a',
  turquoiseTint: '#E7F7FA',
  warningTint: '#FDEEE8',

  // Rail-on-dark text ramp
  railText: '#d6dae1',
  railIcon: '#9aa1ad',
  railSubheader: '#78808f',
  railLeaf: '#aeb5c1',
  railLeafActive: '#fff',
  railBorder: 'rgba(255,255,255,.09)',
  railActiveBg: 'rgba(0,182,224,.16)',
  railLeafActiveBg: 'rgba(255,255,255,.09)',

  // Light surfaces / borders / text
  surface: '#fff',
  border: '#E3E6EB',
  borderSoft: '#F0F1F4',
  text: '#262C37',
  textMid: '#3d4453',
  textMuted: '#6B7380',
  textFaint: '#9aa1ad',
};

export const SHADOW = {
  focusRing: '0 0 0 3px rgba(0,182,224,.18)',
  focusRingStrong: '0 0 0 3px rgba(0,182,224,.30)',
  popover: '0 16px 40px rgba(38,44,55,.22)',
  palette: '0 30px 70px rgba(38,44,55,.35)',
};

export const FONT = theme.typography.fontFamily;

// Counters are work in hand, not a failure, so they read in warning. Past this
// the exact number stops being actionable and the badge would outgrow the icon.
export const COUNT_CAP = 999;
